import React from 'react';
import { useLanguage } from './LanguageContext';

/**
 * EN/TH switch. It renders in three places — the desktop sidebar footer, the
 * phone nav-drawer footer (both --brand-900) and the near-white MobileHeader
 * bar — so its colours cannot be inline: they live in `.lang-toggle` in
 * index.css, with a light variant under `.mobile-header .lang-toggle`. The
 * `bg-white/10 … text-white` this used to carry measured 1.01:1 on the header.
 */
const LanguageToggle = () => {
  const { currentLanguage, toggleLanguage } = useLanguage();

  return (
    <button
      type="button"
      onClick={toggleLanguage}
      className="lang-toggle"
      title={currentLanguage === 'th' ? 'Switch to English' : 'เปลี่ยนเป็นภาษาไทย'}
    >
      <span className={currentLanguage === 'th' ? 'lang-toggle-muted' : ''}>EN</span>
      <span className="lang-toggle-muted">|</span>
      <span className={currentLanguage === 'en' ? 'lang-toggle-muted' : ''}>TH</span>
    </button>
  );
};

export default LanguageToggle;
